/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true, todo: true */

"use strict";

var $ = require("../jquery");
var dateUtil = require("../util/date");
var pli = require("../forms");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function daysEquals(left, right) {
    /// <summary>
    /// Compares the Date (day, month, year) of two javascript dates.
    /// </summary>
    return left.getDate() === right.getDate()
        && left.getMonth() === right.getMonth()
        && left.getFullYear() === right.getFullYear();
}


//-------------------------------------------
function monthsEquals(left, right) {
    /// <summary>
    /// Compares the Month (month, year) of two javascript dates.
    /// </summary>
    return left.getMonth() === right.getMonth()
        && left.getFullYear() === right.getFullYear();
}


//-------------------------------------------
function buildDays(selected) {
    /// <summary>
    /// Builds the table body containing the calendar days
    /// </summary>
    var w, d,
        className = "",
        day = selected,
        html = "",
        today = new Date();

    // Initialize the first date in the calendar (offset the first day of the month by the day of the week index)
    day = dateUtil.moveToFirstDayOfMonth(day);
    day = dateUtil.addDays(day, day.getDay() * -1);

    // Add a spacer row for a gap between header row and days
    html = html.concat("<tr class=\"spacer\"></tr>");

    for (w = 0; w < 6; w += 1) {
        html = html.concat("<tr>");

        for (d = 0; d < 7; d += 1) {

            // build className (out: outside of current month)
            if (daysEquals(day, today)) { className = className.concat("today "); }
            if (day.getMonth() !== selected.getMonth()) { className = className.concat("out "); }
            if (daysEquals(day, selected)) { className = className.concat("selected"); }

            // build table cell for a calendar day
            html = html.concat(className
                ? "<td class=\"".concat(className).concat("\">")
                : "<td>")
                .concat(day.getDate())
                .concat("</td>");

            className = "";
            day = dateUtil.addDays(day, 1); // increment the day
        }

        html = html.concat("</tr>");
    }
    return html;
}


//-------------------------------------------
function buildMonths(selected) {
    /// <summary>
    /// Builds the table body of months 4x3
    /// </summary>
    var r, m, month = selected, html = "";
    month = dateUtil.setMonth(month, 0);

    // creates a 4x3 table of months (MMM)
    for (r = 0; r < 3; r += 1) {
        html = html.concat("<tr>");
        for (m = 0; m < 4; m += 1) {
            html = html.concat((monthsEquals(month, selected) ? "<td class=\"selected\">" : "<td>"))
                .concat(month.toString("MMM"))
                .concat("</td>");
            month = dateUtil.addMonths(month, 1); // increment the month
        }
        html = html.concat("</tr>");
    }
    return html;
}


//-------------------------------------------
function buildCalendarHtml(selected) {
    /// <summary>
    /// Build the html for the calendar control
    /// </summary>
    return "<div id=\"calendarPopup\" class=\"calendarPopup\">"

        // Header
        .concat("<header>")
        .concat("<a class=\"leftNav\"><span class=\"sprite-blueArrowLeft-16\"></span></a>")
        .concat("<div>")
        .concat(selected.toString("MMMM yyyy"))
        .concat("</div>")
        .concat("<a class=\"rightNav\"><span class=\"sprite-blueArrowRight-16\"></span></a>")
        .concat("</header>")

        // Table
        .concat("<section><table>")

        // Week Days
        .concat("<thead>")
        .concat("<tr><th>Su</th><th>Mo</th><th>Tu</th><th>We</th><th>Th</th><th>Fr</th><th>Sa</th></tr>")
        .concat("</thead>")

        // Days
        .concat("<tbody>")
        .concat(buildDays(selected))
        .concat("</tbody>")

        .concat("</table></section>");
}


//-------------------------------------------
function buildMonthHtml(selected) {
    /// <summary>
    /// Build the html for the month calendar control
    /// </summary>
    return "<div id=\"monthPopup\" class=\"calendarPopup monthPopup\">"

        // Header
        .concat("<header>")
        .concat("<a class=\"leftNav\"><span class=\"sprite-blueArrowLeft-16\"></span></a>")
        .concat("<div>")
        .concat(selected.toString("yyyy"))
        .concat("</div>")
        .concat("<a class=\"rightNav\"><span class=\"sprite-blueArrowRight-16\"></span></a>")
        .concat("</header>")

        // Table
        .concat("<section><table>")

        // Months
        .concat("<tbody>")
        .concat(buildMonths(selected))
        .concat("</tbody>")

        .concat("</table></section>");
}


//-------------------------------------------
function positionCalendar($calendar, $document, $element) {
    /// <summary>
    /// Positions the calendar relative to the $element specified
    /// </summary>
    var vw = $document.width(),
        vh = $document.height(),
        offset = $element.offset(),
        cw = $calendar.outerWidth(),
        ch = $calendar.outerHeight(),
        ih = $element.outerHeight();

    // if the calendar is outside of the current document (horizontally)
    // offset by the calendarWidth - width of the input.
    if (offset.left + cw > vw) {
        offset.left = offset.left - (cw - $element.outerWidth());
    }

    // if the calendar is outside of the current document (vertically)
    // offset by the height of the calendar + top border
    // otherwise offset by the height of the input - bottom border
    // border adjustment ensures that the input and calendar borders overlap.
    if (offset.top + ch + ih > vh) {
        offset.top = offset.top - ch + 1;
    } else {
        offset.top = offset.top + ih - 1;
    }
    $calendar.offset(offset);
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PopupControl class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function PopupControl() {
    /// <summary>
    /// Initializes a new instance of the popup control
    /// </summary>
    return;
}


//-------------------------------------------
PopupControl.prototype._internalClose = function popupControlInternalClose(updateValue) {
    /// <summary></summary>

    // Call close handler before data is removed
    this.$calendar.addClass("hidden");
    this._value(updateValue ? this._selected : undefined);

    // Remove event handlers
    this._$element.off("keydown", this._keyDownHandler);
    this.$document.off("mousedown", this._globalMouseDown)
        .off("focusin", this._globalFocus);

    // delete temporary variables
    delete this._value;
    delete this._selected;
    delete this._$element;
    return false;
};


//-------------------------------------------
PopupControl.prototype._globalFocus = function popupControlGlobalFocus() {
    /// <summary>
    /// Cancels calendar pop-up if global focus is lost.
    /// Mostly intended when moving from the address bar back
    /// into the form or when navigating to another page.
    /// </summary>
    if (this._eventInCalendar) { // focus was triggered by clicking within calendar (ignore)
        this._eventInCalendar = false;
    } else if (document.activeElement !== this._$element[0]) {
        this.cancel();
    }
};


//-------------------------------------------
PopupControl.prototype._normalizeFocus = function popupControlNormalizeFocus() {
    /// <summary>
    /// In IE versions < 9, focus cannot be cancelled
    /// from the mousedown event.  Instead setTimeout is used
    /// to re-focus after the click event has finished.
    /// More Information: http://bugs.jquery.com/ticket/10345
    /// </summary>
    if (document.activeElement !== this._$element[0]) { // re-focus if necessary
        this._eventInCalendar = true;
        this._$element.focus();
    }
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CalendarControl class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function CalendarControl() {
    /// <summary>
    /// Initializes a new instance of the calendar control
    /// </summary>
    this.$document = $(document);

    this._globalMouseDown = this._globalMouseDown.bind(this);
    this._globalFocus = this._globalFocus.bind(this);
    this._keyDownHandler = this._keyDownHandler.bind(this);
    this._normalizeFocus = this._normalizeFocus.bind(this);
}


//-------------------------------------------
CalendarControl.prototype.accept = function calendarControlAccept() {
    /// <summary>
    /// Accept the selected date and close the popup.
    /// </summary>
    return this._internalClose(true);
};


//-------------------------------------------
CalendarControl.prototype.cancel = function calendarControlCancel() {
    /// <summary>
    /// Ignore the selected date and close the form
    /// </summary>
    return this._internalClose(false);
};


//-------------------------------------------
CalendarControl.prototype.load = function calendarControlLoad(options) {
    /// <summary>
    /// Loads the selected date and displays the calendar popup.
    /// </summary
    if (typeof options.value !== "function") { throw new Error("options.value must be an observable or function"); }
    var selected = options.value();
    selected = selected || new Date();

    // show the calendar if it exists
    if (this.$calendar) {
        if (!this.$calendar.is(":hidden")) { this.cancel(); } // ensure calendar is cleaned up.
        this.$days.html(buildDays(selected));
        this.$monthHeader.text(selected.toString("MMMM yyyy"));
        this.$calendar.removeClass("hidden");

    // otherwise build the calendar DOM
    } else {
        $("body").append(buildCalendarHtml(selected));
        this.$calendar = $("#calendarPopup");
        this.$days = this.$calendar.find("tbody");
        this.$monthHeader = this.$calendar.find("header > div");
    }
    this._storeAdjustment();

    this._value = options.value;
    this._selected = selected;
    this._$element = options.$element;
    positionCalendar(this.$calendar, this.$document, this._$element);
    this._$element.focus();
    this._$element.on("keydown", this._keyDownHandler);
    this.$document.on("mousedown", this._globalMouseDown).on("focusin", this._globalFocus);
};



//-------------------------------------------
CalendarControl.prototype._adjust = function calendarControlAdjust() {
    /// <summary>
    /// Adjusts the date to the last selected date or
    /// last day of the month.  Meant to be used with PageUp and PageDown
    /// to keep the last selected date via arrow keys.
    /// </summary>
    if (this._isLastDay) {
        this._selected = dateUtil.moveToLastDayOfMonth(this._selected);
    } else if (this._selected.getDate() !== this._adjustment.getDate() && this._adjustment.getDate() >= 28) {
        this._selected = dateUtil.setDate(this._selected, Math.min(
            Date.getDaysInMonth(this._selected.getFullYear(), this._selected.getMonth()),
            this._adjustment.getDate()
        ));
    }
};


//-------------------------------------------
CalendarControl.prototype._internalClose = PopupControl.prototype._internalClose;


//-------------------------------------------
CalendarControl.prototype._storeAdjustment = function calendarControlStoreAdjustment() {
    /// <summary>
    /// Stores the last selected date in order to adjust the date to
    /// maintain the last selected date.  (used by _adjust function)
    /// </summary>
    this._adjustment = new Date(this._selected);
    this._isLastDay = this._adjustment.getDate() === Date.getDaysInMonth(this._adjustment.getFullYear(), this._adjustment.getMonth());
};


//-------------------------------------------
CalendarControl.prototype._globalMouseDown = function calendarControlGlobalMouseDown(e) {
    /// <summary>
    /// Handles the global mouse down click.
    /// Cancels the calendar popup if clicking outside of the calendar.
    /// </summary>
    var $a, d,
        $target = $(e.target),
        $popup = $target.closest(".calendarPopup");

    if ($popup.length !== 0) {

        // Handle left/right arrows or cell
        $a = $target.closest(".leftNav, .rightNav, td");
        if ($a.length !== 0) {
            if ($a.is(".leftNav")) {
                this._selected = dateUtil.addMonths(this._selected, -1);
                this._adjust();
                this._refresh();
            } else if ($a.is(".rightNav")) {
                this._selected = dateUtil.addMonths(this._selected, 1);
                this._adjust();
                this._refresh();
            } else {
                d = parseInt($a.text(), 10);
                if ($a.is(".out")) { this._selected = dateUtil.addMonths(this._selected, d > 15 ? -1 : 1); }
                this._selected = dateUtil.setDate(this._selected, d);
                this.accept();
                return false;
            }
        }
        this._eventInCalendar = true;
        setTimeout(this._normalizeFocus, 0);

    } else {
        this.cancel();
    }
};


//-------------------------------------------
CalendarControl.prototype._globalFocus = PopupControl.prototype._globalFocus;


//-------------------------------------------
CalendarControl.prototype._keyDownHandler = function calendarControlKeyDownHandler(e) {
    /// <summary>
    /// Handles keyboard accessibility of the calendar pop-up.
    /// </summary>
    switch (e.which) {
    case 13: // Enter
        this.accept();
        return false;
    case 27: // Escape
        this.cancel();
        return false;
    case 9: // Tab
        this._selected = dateUtil.addDays(this._selected, e.shiftKey ? -1 : 1);
        this._refresh(true);
        this._$element.focus();
        return false;
    case 33: // PageUp
        this._selected = dateUtil.addMonths(this._selected, -1);
        this._adjust();
        this._refresh();
        return false;
    case 34: // PageDown
        this._selected = dateUtil.addMonths(this._selected, 1);
        this._adjust();
        this._refresh();
        return false;
    case 38: // Up
        this._selected = dateUtil.addDays(this._selected, -7);
        this._refresh(true);
        return false;
    case 37: // Left
        this._selected = dateUtil.addDays(this._selected, -1);
        this._refresh(true);
        return false;
    case 39: // Right
        this._selected = dateUtil.addDays(this._selected, 1);
        this._refresh(true);
        return false;
    case 40: // Down
        this._selected = dateUtil.addDays(this._selected, 7);
        this._refresh(true);
        return false;
    }
};


//-------------------------------------------
CalendarControl.prototype._normalizeFocus = PopupControl.prototype._normalizeFocus;


//-------------------------------------------
CalendarControl.prototype._refresh = function calendarControlRefresh(storeAdjustment) {
    /// <summary>
    /// Re-renders the calendar days based on the selection.
    /// </summary>
    /// <param name="storeAdjustment">
    /// true if the last selected date is stored otherwise false
    /// </summary>
    this.$days.html(buildDays(this._selected));
    this.$monthHeader.text(this._selected.toString("MMMM yyyy"));
    if (storeAdjustment) { this._storeAdjustment(); }
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// MonthControl class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function MonthControl() {
    /// <summary>
    /// Initializes a new instance of the month calendar control
    /// </summary>
    this.$document = $(document);

    this._globalMouseDown = this._globalMouseDown.bind(this);
    this._globalFocus = this._globalFocus.bind(this);
    this._keyDownHandler = this._keyDownHandler.bind(this);
    this._normalizeFocus = this._normalizeFocus.bind(this);
}


//-------------------------------------------
MonthControl.prototype.accept = function MonthControlAccept() {
    /// <summary>
    /// Accept the selected date and close the popup.
    /// </summary>
    return this._internalClose(true);
};


//-------------------------------------------
MonthControl.prototype.cancel = function MonthControlCancel() {
    /// <summary>
    /// Ignore the selected date and close the form
    /// </summary>
    return this._internalClose();
};


//-------------------------------------------
MonthControl.prototype.load = function MonthControlLoad(options) {
    /// <summary>
    /// Loads the selected date and displays the month calendar popup.
    /// </summary
    if (typeof options.value !== "function") { throw new Error("options.value must be an observable or function"); }
    var selected = options.value();
    selected = selected || new Date();
    selected = dateUtil.moveToFirstDayOfMonth(selected); // clear date and time
    selected = dateUtil.clearTime(selected);

    // show the month calendar if it exists
    if (this.$calendar) {
        if (!this.$calendar.is(":hidden")) { this.cancel(); } // ensure calendar is cleaned up.
        this.$months.removeClass("selected");
        this.$months.eq(selected.getMonth()).addClass("selected");
        this.$yearHeader.text(selected.toString("yyyy"));
        this.$calendar.removeClass("hidden");

    // otherwise build the calendar DOM
    } else {
        $("body").append(buildMonthHtml(selected));
        this.$calendar = $("#monthPopup");
        this.$months = this.$calendar.find("td");
        this.$yearHeader = this.$calendar.find("header > div");
    }

    this._value = options.value;
    this._selected = selected;
    this._$element = options.$element;
    positionCalendar(this.$calendar, this.$document, this._$element);
    this._$element.focus();
    this._$element.on("keydown", this._keyDownHandler);
    this.$document.on("mousedown", this._globalMouseDown).on("focusin", this._globalFocus);
};


//-------------------------------------------
MonthControl.prototype._internalClose = PopupControl.prototype._internalClose;


//-------------------------------------------
MonthControl.prototype._globalMouseDown = function MonthControlGlobalMouseDown(e) {
    /// <summary>
    /// Handles the global mouse down click.
    /// Cancels the calendar popup if clicking outside of the calendar.
    /// </summary>
    var $a,
        $target = $(e.target),
        $popup = $target.closest(".calendarPopup");

    if ($popup.length !== 0) {

        // Handle left/right arrows or cell
        $a = $target.closest(".leftNav, .rightNav, td");
        if ($a.length !== 0) {
            if ($a.is(".leftNav")) {
                this._selected = dateUtil.addYears(this._selected, -1);
                this._refresh();
            } else if ($a.is(".rightNav")) {
                this._selected = dateUtil.addYears(this._selected, 1);
                this._refresh();
            } else {
                this._selected = dateUtil.setMonth(this._selected, Date.getMonthNumberFromName($a.text()));
                this.accept();
                return false;
            }
        }
        this._eventInCalendar = true;
        setTimeout(this._normalizeFocus, 0);

    } else {
        this.cancel();
    }
};


//-------------------------------------------
MonthControl.prototype._globalFocus = PopupControl.prototype._globalFocus;


//-------------------------------------------
MonthControl.prototype._keyDownHandler = function MonthControlKeyDownHandler(e) {
    /// <summary>
    /// Handles keyboard accessibility of the month calendar pop-up.
    /// </summary>
    switch (e.which) {
    case 13: // Enter
        this.accept();
        return false;
    case 27: // Escape
        this.cancel();
        return false;
    case 9: // Tab
        this._selected = dateUtil.addMonths(this._selected, e.shiftKey ? -1 : 1);
        this._refresh();
        this._$element.focus();
        return false;
    case 33: // PageUp
        this._selected = dateUtil.addYears(this._selected, -1);
        this._refresh();
        return false;
    case 34: // PageDown
        this._selected = dateUtil.addYears(this._selected, 1);
        this._refresh();
        return false;
    case 38: // Up
        this._selected = dateUtil.addMonths(this._selected, -4);
        this._refresh();
        return false;
    case 37: // Left
        this._selected = dateUtil.addMonths(this._selected, -1);
        this._refresh();
        return false;
    case 39: // Right
        this._selected = dateUtil.addMonths(this._selected, 1);
        this._refresh();
        return false;
    case 40: // Down
        this._selected = dateUtil.addMonths(this._selected, 4);
        this._refresh();
        return false;
    }
};


//-------------------------------------------
MonthControl.prototype._normalizeFocus = PopupControl.prototype._normalizeFocus;


//-------------------------------------------
MonthControl.prototype._refresh = function MonthControlRefresh() {
    /// <summary>
    /// Re-renders the calendar days based on the selection.
    /// </summary>
    this.$months.removeClass("selected");
    this.$months.eq(this._selected.getMonth()).addClass("selected");
    this.$yearHeader.text(this._selected.toString("yyyy"));
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// TODO: Create separate modules
pli.forms.registry.dateSelector = new CalendarControl();
pli.forms.registry.monthSelector = new MonthControl();

module.exports = pli;




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols-date/dateForm.js
// module id = 452
// module chunks = 49